import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  Button,
  // Carousel,
} from "react-bootstrap";

import { FiPlus, FiMinus } from "react-icons/fi";
import { IoArrowForwardOutline } from "react-icons/io5";

// import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";


import CourseBannerImage from "../../assets/publicpageimg/tutor-programme-img.png";

import applyTutor from "../../assets/publicpageimg/apply-tutor.svg";
import getApproved from "../../assets/publicpageimg/get-approved.svg";
import startTeaching from "../../assets/publicpageimg/start-teaching.svg";


// old img
// import courseHosting from "../../assets/publicpageimg/course-hosting-video-delivery.svg";
// import studentAnalytics from "../../assets/publicpageimg/student-management-analytics.svg";
// import assignmentsCertificates from "../../assets/publicpageimg/assignments-certificates.svg";
// import paymentsInvoicing from "../../assets/publicpageimg/payments-invoicing.svg";
// import marketingAcquisition from "../../assets/publicpageimg/marketing-learner-acquisition.svg";

// latest img
import skilleditionLearning from "../../assets/publicpageimg/skilledition-lp.svg";
import courseHosting from "../../assets/publicpageimg/course-hosting-vd.svg";
import studentFdRating from "../../assets/publicpageimg/student-fd-rating.svg";
import onlineTeachingPlat from "../../assets/publicpageimg/online-teaching-platform.svg";
import paymentsInvoicing from "../../assets/publicpageimg/payments-invoice.svg";
import marketingAcquisition from "../../assets/publicpageimg/marketing-lear-acquisi.svg";

// import Students from "../../assets/publicpageimg/Students & Freshers.png";
// import Career from "../../assets/publicpageimg/Career Switchers.png";
// import Developers from "../../assets/publicpageimg/Developers Looking.png";

// import SuccessStory from "../../assets/publicpageimg/review-avatar.png";

// import CareersImage from "../../assets/publicpageimg/crypto-technology.svg";
import CareersImage from "../../assets/publicpageimg/teach-multiple-domain.png";

import HomeBanner from "../../assets/publicpageimg/teach-what-you-know-earn.png";

import "./TutorProgramme.css";

const faqsData = [
  {
    question: "Who can become a Skilledition tutor?",
    answer:
      "Anyone with subject expertise, industry experience, or strong knowledge in a skill area can apply. We welcome educators, professionals, and trainers from diverse fields who want to share their expertise.",
  },
  {
    question: "How do I apply?",
    answer:
      "Click Join as Tutor, complete the onboarding process, and submit your application. Our team will review your details and guide you through the next steps.",
  },
  {
    question: "Can I teach multiple subjects?",
    answer:
      "Yes. If you have expertise in more than one domain, you can mentor across different categories and expand your impact.",
  },
  {
    question: "How do tutor earn with Skilledition?",
    answer:
      "Tutor at Skilledition can choose how they earn either through a one‑time settlement, where they receive a fixed payment for their overall contribution, or through a royalty model, where they earn ongoing income based on the number of student enrollments in their courses. ",
  },
  {
    question: "What support will I get as tutor?",
    answer:
      "Skilledition provides ongoing support including teaching resources, analytics on learner engagement, and a dedicated team to help you succeed. You’ll also be part of a community of mentors where you can share insights and grow together.",
  },
];

// const successStoriesData = [
//   {
//     name: "Sathish Kumar",
//     role: "Full Stack Tutor",
//     image: SuccessStory,
//     description:
//       "Partnering with Skilledition allowed me to deliver industry-focused full-stack training through real-time projects. The platform supports tutors in structuring courses and reaching motivated learners.",
//   },
//   {
//     name: "Ravi Teja",
//     role: "Frontend Development Tutor",
//     image: SuccessStory,
//     description:
//       "As a frontend tutor, Skilledition gave me the opportunity to teach HTML, CSS, Bootstrap, and React using practical examples. The collaboration made course delivery smooth and impactful.",
//   },
//   {
//     name: "Anjali Sharma",
//     role: "UI/UX Design Mentor",
//     image: SuccessStory,
//     description:
//       "Skilledition encouraged me to design a practical UI/UX curriculum aligned with industry standards. I was able to mentor students using real design workflows and portfolio-based learning.",
//   },
//   {
//     name: "Rohit Verma",
//     role: "Backend Development Tutor",
//     image: SuccessStory,
//     description:
//       "Teaching backend technologies like Node.js, Express, MongoDB, and AWS through Skilledition was seamless. The platform supports tutors with structured delivery and real-world project integration.",
//   },
//   {
//     name: "Sneha Rao",
//     role: "Digital Marketing Trainer",
//     image: SuccessStory,
//     description:
//       "Skilledition enabled me to conduct hands-on digital marketing training covering SEO, ads, and social media. Tutors are encouraged to focus on practical campaigns and real tools.",
//   },
//   {
//     name: "Vivek Yadav",
//     role: "React & Frontend Mentor",
//     image: SuccessStory,
//     description:
//       "Collaborating with Skilledition helped me mentor learners on React fundamentals and component-based development using industry-relevant projects and best practices.",
//   },
//   {
//     name: "Meera Iyer",
//     role: "Content & Social Media Tutor",
//     image: SuccessStory,
//     description:
//       "As a content marketing tutor, I was able to guide learners through real campaign planning and analytics. Skilledition provides strong academic and operational support for tutors.",
//   },
//   {
//     name: "Aditya Sharma",
//     role: "Technical Mentor – Full Stack",
//     image: SuccessStory,
//     description:
//       "Skilledition values tutor expertise and encourages practical teaching. I was able to deliver structured full-stack sessions backed by real-time use cases and mentorship.",
//   },
//   {
//     name: "Ritika Sen",
//     role: "SEO & Performance Marketing Tutor",
//     image: SuccessStory,
//     description:
//       "Teaching SEO and paid marketing through Skilledition allowed me to focus on real optimization strategies. Tutors get flexibility to design content aligned with current market trends.",
//   },
//   {
//     name: "Sahil Kapoor",
//     role: "Frontend & JavaScript Tutor",
//     image: SuccessStory,
//     description:
//       "Skilledition supports tutors in delivering hands-on frontend training using live projects. The platform makes it easy to engage learners and maintain industry relevance.",
//   },
// ];

const aboutCards = [
  {
    image: skilleditionLearning,
    text: "Skilledition Learning Platform",
  },
  {
    image: courseHosting,
    text: "Course hosting & video delivery",
  },
  {
    image: studentFdRating,
    text: "Student Feedback & Ratings",
  },
  {
    image: onlineTeachingPlat,
    text: "Online Teaching Platform",
  },
  {
    image: paymentsInvoicing,
    text: "Payments, payouts & invoicing",
  },
  {
    image: marketingAcquisition,
    text: "Marketing & learner acquisition",
  },
];

const CourseDetailPage = () => {
  const [activeKey, setActiveKey] = useState("0");
  const navigate = useNavigate();

  const openWhatsApp = () => {
    const phoneNumber = "918143879627";
    const message =
      "Thanks for reaching out on WhatsApp. If you're interested in becoming a tutor, send us a message. We'll guide you through registration and onboarding.";
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank",
    );
  };

  return (
    <>
      <Helmet>
        <title>
          Skilledition | Expert Tutors – Learn from Industry Professionals
        </title>

        <meta
          name="description"
          content="Learn from Skilledition’s expert tutors who bring real industry experience, mentorship, and practical teaching methods."
        />

        <link rel="canonical" href="https://skilledition.in/tutor" />

        {/* Open Graph / Social Share */}
        <meta
          property="og:title"
          content="Skilledition | Expert Tutors – Learn from Industry Professionals"
        />
        <meta
          property="og:description"
          content="Meet industry professionals guiding learners with real-world knowledge and mentorship."
        />
        <meta property="og:url" content="https://skilledition.in/tutor" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner-tutor.png"
        />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Skilledition | Expert Tutors – Learn from Industry Professionals"
        />
        <meta
          name="twitter:description"
          content="Meet industry professionals guiding learners with real-world knowledge and mentorship."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner-tutor.png"
        />
      </Helmet>

      <section className="skilledition-builds-section reveal">
        <Container className="skilledition-builds-section-container">
          <Row className="skilledition-builds-section-row align-items-center">
            {/* LEFT CONTENT */}
            <Col lg={6} className="skilledition-builds-section-left">
              <h1 className="skilledition-builds-section-title">
                Your Knowledge Can Launch Careers
              </h1>

              <p className="skilledition-builds-section-description">
                Join Skilledition as a mentor share your expertise, teach
                in‑demand skills, and help learners become job‑ready while
                growing your presence in the tech community.
              </p>

              <div className="skilledition-builds-section-buttons">
                <Button
                  className="skilledition-banner-section-btn"
                  onClick={() => navigate("/signin")}
                >
                  Join as Tutor <IoArrowForwardOutline />
                </Button>
              </div>
            </Col>

            {/* RIGHT IMAGE */}
            <Col lg={6} className="skilledition-builds-section-right">
              <img
                src={CourseBannerImage}
                alt="MERN Course Banner"
                className="skilledition-builds-section-image"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-whoaboutpage-section reveal">
        <Container>
          <div className="mb-3 skilledition-whoaboutpage-total-div">
            <h2 className="skilledition-whoaboutpage-title">
              Ready to Start Mentoring
            </h2>

            <p className="skilledition-whoaboutpage-desc">
              Start your teaching journey with Skilledition, share your
              expertise, and help learners develop job-ready skills
            </p>
          </div>

          <Row className="skilledition-internship-program-who-items-row justify-content-center">
            <Col lg={4} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={applyTutor}
                    alt="apply Tutor"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Apply as a Tutor
                  </Card.Title>
                  <Card.Text
                    className="skilledition-whoaboutpage-card-text"
                    style={{ textAlign: "center" }}
                  >
                    Create your profile by sharing your skills and experience to
                    get matched with the right teaching opportunities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={getApproved}
                    alt="get Approved"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Get Approved
                  </Card.Title>
                  <Card.Text
                    className="skilledition-whoaboutpage-card-text"
                    style={{ textAlign: "center" }}
                  >
                    Our review team evaluates your profile to ensure quality,
                    relevance, and teaching readiness.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={startTeaching}
                    alt="start Teaching"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Start Teaching
                  </Card.Title>
                  <Card.Text
                    className="skilledition-whoaboutpage-card-text"
                    style={{ textAlign: "center" }}
                  >
                    Create recorded courses, mentor learners through structured
                    content, and earn based on enrollments.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-internship-portfolio-section reveal">
        <Container>
          {/* HEADER */}
          <div className="skilledition-internship-portfolio-header text-center">
            <h2 className="skilledition-internship-portfolio-title">
              Why Tutors Choose Skilledition?
            </h2>
          </div>

          {/* CARDS */}
          <Row className="skilledition-tutorprogramme-portfolio-cards">
            <Col lg={6} md={12}>
              <Card className="skilledition-internship-program-portfolio-card">
                <h5 className="skilledition-internship-program-portfolio-card-title">
                  Turn Skills into Income
                </h5>
                <ul className="skilledition-internship-program-portfolio-list">
                  <li>Transform Your Expertise into Income</li>
                  <li>Earn Income with Every Enrollment</li>
                  <li>Transparent & Reliable Monthly Payouts</li>
                </ul>
              </Card>
            </Col>

            <Col lg={6} md={12}>
              <Card className="skilledition-internship-program-portfolio-card">
                <h5 className="skilledition-internship-program-portfolio-card-title">
                  Flexible Teaching Experience
                </h5>
                <ul className="skilledition-internship-program-portfolio-list">
                  <li>Teach from anywhere, anytime.</li>
                  <li>Publish Recorded Courses & Earn.</li>
                  <li>
                    Balance teaching with your full-time career or business.
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>

          {/* BOTTOM SUPPORT BOX */}
          {/* <div className="skilledition-internship-program-portfolio-support">
            <h6 className="skilledition-internship-program-portfolio-support-title">
              Growth & Impact
            </h6>
            <ul className="skilledition-internship-program-portfolio-support-list">
              <li>Build your personal educator profile</li>
              <li>Get featured as a top instructor on Skilledition</li>
              <li>Help learners build job-ready, real-world skills</li>
            </ul>
          </div> */}

          <Row className="justify-content-center">
            <Col lg={6} md={12}>
              <Card className="skilledition-internship-program-portfolio-card">
                <h5 className="skilledition-internship-program-portfolio-card-title">
                  Growth & Impact
                </h5>

                <ul className="skilledition-internship-program-portfolio-support-list">
                  <li>Build your personal educator profile</li>
                  <li>Get featured as a top instructor on Skilledition</li>
                  <li>Help learners build job-ready, real-world skills</li>
                </ul>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-aboutpage-careers-section reveal">
        <Container>
          <Row className="align-items-center">
            {/* LEFT CONTENT */}
            <Col lg={6}>
              <h2 className="skilledition-aboutpage-careers-title">
                Teach Across Multiple Domains
              </h2>
              <ul className="skilledition-tutor-programmer-careers-list">
                <li>
                  <span>✓</span>
                  Full Stack Web Development
                </li>
                <li>
                  <span>✓</span>
                  Frontend Development
                </li>
                <li>
                  <span>✓</span>
                  Backend Development
                </li>
                <li>
                  <span>✓</span>
                  AI Prompt Engineering
                </li>
                <li>
                  <span>✓</span>
                  Cybersecurity
                </li>
                <li>
                  <span>✓</span>
                  Cloud Computing
                </li>
                <li>
                  <span>✓</span>
                  UI/UX Design
                </li>
                <li>
                  <span>✓</span>
                  IT Sales
                </li>
                <li>
                  <span>✓</span>
                  Digital Marketing
                </li>
              </ul>

              <button
                className="skilledition-aboutpage-careers-btn"
                // onClick={() => navigate("/contact")}
                onClick={openWhatsApp}
              >
                Let's Connect
              </button>
            </Col>

            {/* RIGHT IMAGE */}
            <Col lg={6} className="text-center">
              <div className="skilledition-aboutpage-careers-image-wrapper">
                <img
                  src={CareersImage}
                  alt="Industry Ready Skills"
                  className="skilledition-tutor-careers-small-image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-internshipcareer-section reveal">
        <Container className="skilledition-internshipcareer-container">
          <Row className="mb-3 justify-content-center">
            <Col lg={10} className="text-center">
              <h2 className="skilledition-internshipcareer-title">
                What We Provide (You Focus on Teaching)
              </h2>
            </Col>
          </Row>

          <Row>
            {aboutCards.map((item, index) => (
              <Col lg={4} md={6} sm={1} className="mb-4" key={index}>
                <Card className="skilledition-tutorprogramme-card">
                  <div className="skilledition-internshipcareer-program-card-image">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="skilledition-internshipcareer-program-card-icon-img"
                    />
                  </div>

                  <Card.Body className="p-0">
                    <Card.Text className="skilledition-tutorprogramme-card-title">
                      {item.text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* <section className="skilledition-stories-section reveal">
        <Container fluid className="p-0 skilledition-stories-container">
          <h2 className="skilledition-stories-title">Success Stories</h2>

          <Carousel
            indicators={false}
            controls={false}
            interval={4000}
            pause={false}
            className="skilledition-stories-carousel"
          >
            {successStoriesData.map((story, index) => (
              <Carousel.Item key={index}>
                <div className="skilledition-story-card">
                  <p className="skilledition-story-text">{story.description}</p>

                  <div className="skilledition-story-user">
                    <img
                      src={story.image}
                      alt={story.name}
                      className="skilledition-story-user-img"
                    />
                    <div className="skilledition-story-user-info">
                      <h6 className="skilledition-story-user-name">
                        {story.name}
                      </h6>
                      <span className="skilledition-story-user-role">
                        {story.role}
                      </span>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </section> */}

      <section className="skilledition-faqs-section reveal">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col lg={5} className="skilledition-faqs-left">
              <h2 className="skilledition-faqs-title">
                Frequently asked <br /> questions.
              </h2>
              <p className="skilledition-faqs-desc">
                Skilledition is designed to answer common questions clearly and
                help learners understand our platform easily.
              </p>
            </Col>

            {/* RIGHT FAQ */}
            <Col lg={7} className="skilledition-faqs-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-faqs-accordion"
              >
                {faqsData.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-faq-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                    >
                      <span className="skilledition-faq-question">
                        {faq.question}
                      </span>

                      <span className="skilledition-faq-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-faq-answer">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-banner-section reveal">
        <Container>
          <div className="skilledition-banner-section-wrapper">
            <div className="skilledition-banner-section-left">
              <h2 className="skilledition-banner-section-title">
                Teach What You Know, Earn What You Deserve
              </h2>

              <p className="skilledition-banner-section-text">
                Share your expertise, mentor learners, build your reputation,
                and earn while shaping future careers.
              </p>

              <Button
                className="skilledition-banner-section-btn"
                onClick={() => navigate("/signin")}
              >
                Join as Tutor <IoArrowForwardOutline />
              </Button>
            </div>

            <div className="skilledition-banner-section-right">
              <img
                src={HomeBanner}
                alt="Dashboard Preview"
                className="skilledition-banner-section-image"
              />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default CourseDetailPage;
